export function sortByDateOldest(key) {
  return function(a,b) {
    if(a[key] === null || a[key] === undefined){
      return -1;
    }
      else if(b[key] === null || b[key] === undefined){
        return 1;
      }
      else if(a[key] === b[key]){
        return 0;
      }
      else if(key) {
        return a[key] > b[key] ? 1 : a[key] < b[key] ? -1 : 0;
      }
    }
  }

  export function sortByDateLatest(key) {
    return function(a,b) {
      if(a[key] === null || a[key] === undefined){
        return 1;
      }
        else if(b[key] === null || b[key] === undefined){
          return -1;
        }
        else if(a[key] === b[key]){
          return 0;
        }
        else if(key) {
          return a[key] < b[key] ? 1 : a[key] > b[key] ? -1 : 0;
        }
      }
    }

  export function sortByAlphabetAesc(key) {
    return function(a, b) {
      if(a[key] === null || a[key] === undefined){
        return 1;
      }
      else if(b[key] === null || b[key] === undefined){
        return -1;
      }
      else if(a[key] === b[key]){
        return 0;
      }
      else if(key) {
        const capA = a[key].toUpperCase();
        const capB = b[key].toUpperCase();
        return (capA < capB) ? -1 : (capA > capB) ? 1 : 0;
      }
    }
  }

  export function sortByAlphabetDesc(key) {
    return function(a, b) {
      if(a[key] === null || a[key] === undefined){
        return -1;
      }
      else if(b[key] === null || b[key] === undefined){
        return 1;
      }
      else if(a[key] === b[key]){
        return 0;
      }
      else if(key) {
        const capA = a[key].toUpperCase();
        const capB = b[key].toUpperCase();
        return (capA > capB) ? -1 : (capA < capB) ? 1 : 0;
      }
    }
  }



// WEBPACK FOOTER //
// ./src/utils/sort.js